import { call, put } from 'redux-saga/effects';
import {
  createExcelContactFailure,
  createExcelContactSuccess,
  fetchOrganisationContactsRequest,
} from '../actions';
import { createExcelContact } from '../api';
import { CreateExcelContactRequestAction } from '../types';
import { ApiError, ApiResponse } from 'store/api/types';
import { checkResponse } from 'store/utils';
import { logoutRequest } from 'store/auth/actions';
import { MessageData } from 'store/app/types';
import { turnMessageOn } from 'store/app/actions';
import { renderErrorMessage } from 'utils/render-error-message';
import { MessageStates } from 'containers/MessageBox';
import i18n from 'i18next';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* createExcelContactSaga(
  action: CreateExcelContactRequestAction
) {
  try {
    const { organisationId, excelContact } = action.payload;

    const response: ApiResponse = yield call(
      createExcelContact,
      organisationId,
      excelContact
    );

    const err: ApiError | null = checkResponse(response?.responseMessage);
    if (err) throw err;

    yield put(createExcelContactSuccess());

    const message: MessageData = {
      title: i18n.t('common.success'),
      description: response.responseMessage.message,
      type: MessageStates.SUCCESS,
    };
    yield put(turnMessageOn(message));
    yield put(fetchOrganisationContactsRequest(organisationId));
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(createExcelContactFailure());
  }
}
